

export const LOADING_START = "LOADING_START"
export const LOADING_END = "LOADING_END"

export const GET_ALL_K_REPO = "GET_ALL_K_REPO"
export const GET_ALL_K_REPO_SUCCESS = "GET_ALL_K_REPO_SUCCESS"

export const GET_ALL_COLLABORATION = "GET_ALL_COLLABORATION"
export const GET_ALL_COLLABORATION_SUCCESS = "GET_ALL_COLLABORATION_SUCCESS"

export const GET_ALL_RESEARCH = "GET_ALL_RESEARCH"
export const GET_ALL_RESEARCH_SUCCESS = "GET_ALL_RESEARCH_SUCCESS"

export const GET_ALL_ONGOING_PROJECT = "GET_ALL_ONGOING_PROJECT"
export const GET_ALL_ONGOING_PROJECT_SUCCESS = "GET_ALL_ONGOING_PROJECT_SUCCESS"
export const GET_ALL_UPCOMING_PROJECT = "GET_ALL_UPCOMING_PROJECT"
export const GET_ALL_UPCOMING_PROJECT_SUCCESS = "GET_ALL_UPCOMING_PROJECT_SUCCESS"

export const GET_ALL_TEAM_MEMBERS = "GET_ALL_TEAM_MEMBERS"
export const GET_ALL_TEAM_MEMBERS_SUCCESS = "GET_ALL_TEAM_MEMBERS_SUCCESS"

export const GET_ALL_EVENTS = "GET_ALL_EVENTS"
export const GET_ALL_EVENTS_SUCCESS = "GET_ALL_EVENTS_SUCCESS"

export const GET_ALL_ANNOUNCEMENTS = "GET_ALL_ANNOUNCEMENTS"
export const GET_ALL_ANNOUNCEMENTS_SUCCESS = "GET_ALL_ANNOUNCEMENTS_SUCCESS"

export const GET_ALL_VACANCIES = "GET_ALL_VACANCIES"
export const GET_ALL_VACANCIES_SUCCESS = "GET_ALL_VACANCIES_SUCCESS"

export const GET_ALL_BANNERS = "GET_ALL_BANNERS"
export const GET_ALL_BANNERS_SUCCESS = "GET_ALL_BANNERS_SUCCESS"

